import Vue from 'vue';
import Router from 'vue-router';
import Login from './views/Login.vue';
import { checkUser } from './lib/iam';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'login',
      component: Login,
    },
    {
      path: '/register',
      name: 'register',
      component: Login,
      meta: {
        registrationFlow: true,
      },
    },
    {
      path: '/account',
      name: 'account',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "account" */ './views/Account.vue'),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/faq',
      name: 'faq',
      component: () => import(/* webpackChunkName: "faq" */ './views/Faq.vue'),
    },
    {
      path: '/home',
      name: 'home',
      component: () => import(/* webpackChunkName: "home" */ './views/Home.vue'),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/materials',
      name: 'materials',
      component: () => import(/* webpackChunkName: "materials" */ './views/Materials.vue'),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/simulations',
      name: 'activity',
      component: () => import(/* webpackChunkName: "activity" */ './views/Activity.vue'),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/simulations/new',
      name: 'simulation',
      component: () => import(/* webpackChunkName: "simulation" */ './views/Simulation.vue'),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/simulations/:id',
      name: 'result',
      component: () => import(/* webpackChunkName: "result" */ './views/Result.vue'),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/simulations/:id/report',
      name: 'report',
      component: () => import(/* webpackChunkName: "report" */ './views/Report.vue'),
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: '/terms',
      name: 'terms',
      component: () => import(/* webpackChunkName: "terms" */ './views/Terms.vue'),
    },
  ],
});

// !store.state.iam.user or !store.getters['iam/isAuth']
router.beforeEach((to, from, next) => {
  // only available during E2E tests
  if (window.Cypress) {
    next();
  } else {
    const validUser = checkUser();
    const requiresAuth = to.matched.some((record) => record.meta.requiresAuth);
    if (requiresAuth && !validUser) {
      next('/');
    } else {
      next();
    }
  }
});

export default router;
